<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Branch</label>
            <div class="col-lg-6">
              <select name="tahun" id="branch" class="custom-select" v-model="branch">
                <option value="0">All</option>
                <template v-for="bran in branchs">
                  <option v-bind:value="bran.id.toString()" :key="bran.id">{{bran.name}}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Periode</label>
            <div class="col-lg-6">
              <date-picker v-model="month" lang="en" format="MMMM YYYY" type="month"></date-picker>
            </div>

          </div>
          <div class="form-group row">
            <button class="btn btn-primary" @click="submit">Submit</button>&nbsp;
            <button class="btn btn-success" @click="print" :disabled="!loading">Print</button>
          </div>

          <br>
          <template v-if="loading">
            <div class="table-responsive table-height">

              <table class="table table-bordered table-sticky">
                <thead class="bg-warning">
                <tr>
                  <th>No</th>
                  <th>Nama
                    <div class="show-arrow">
              <span class="fa fa-chevron-left fa-2x "
                  title="Hide"
              v-if="hidenn" @click="hidenn = !hidenn"
              ></span>
                      <span class="fa fa-chevron-right fa-2x "
                      v-if="!hidenn" @click="hidenn = !hidenn"
                          title="Show"
                      ></span>
                    </div>
                  </th>
<!--                  <template v-if="hidenn">-->
                  <template v-if="hidenn">
                    <th>Absen</th>
                    <th>Tgl Absen</th>
                    <th>Desentif Absen</th>
                  </template>
                  <th>Telat Terdenda</th>
                  <th>Tanggal Telat terdenda</th>
                  <th>Desentive Telat</th>
                  <template v-if="hidenn">
                  <th>Desentive Total</th>
                  </template>
                  <th>Note</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(desentif, indeks) in listDesentif ">
                  <tr>
                    <td>{{indeks + 1}}</td>
                    <td>{{desentif.name}}</td>
                    <template v-if="hidenn">
                      <td align="center">
                        <template>
                          <template v-if="desentif.absen.desentif != 0">
                            {{desentif.absen.desentif_detail.detail.absen_terdenda.length}}
                          </template>
                        </template>
                      </td>
                      <td>
                        <template v-if="desentif.absen.desentif_detail.detail.absen_terdenda.length > 0">
                          {{ desentif.absen.desentif_detail.detail.absen_terdenda | groupDate}}
                        </template>
                      </td>
                      <td align="right">
                        {{desentif.absen.desentif | pointmoneynotCurrency}}
                      </td>
                    </template>
                    <td align="center">
                      <template v-if="desentif.telat.desentif != 0">
                        {{desentif.telat.desentif_detail.detail.telat_terdenda.length}}
                      </template>
                    </td>
                    <td>
<!--                      <template v-if="desentif.telat.desentif_detail.detail.length > 0 && desentif.telat.desentif != 0">-->
                      <template v-if=" desentif.telat.desentif_detail.length == undefined && desentif.telat.desentif != 0">
                        <!--                      <template v-for="tebus in desentif.desentif_detail.detail.tidak_tebus">-->
                        <!--                        <span>{{tebus}} &nbsp;</span>-->
                        <!--                      </template>-->
                        {{ desentif.telat.desentif_detail.detail.telat_terdenda| groupDate}}
                      </template>
                    </td>
                    <td align="right">
                      {{desentif.telat.desentif | pointmoneynotCurrency}}
                    </td>
                    <template v-if="hidenn">
                    <td align="right" @click="detailDesentive(desentif.telat, desentif.name)">
                      {{ (desentif.telat.desentif + desentif.absen.desentif ) | pointmoneynotCurrency}}
                    </td>
                    </template>
                    <td>
                      <template v-if="desentif.telat.desentif_detail.length == undefined">
                        <template v-if="desentif.telat.desentif_detail.detail.tebus_bulan_depan.length > 0">
                          <strong>Proses Tebus</strong> &nbsp;

                          {{desentif.telat.desentif_detail.detail.tebus_bulan_depan | groupDate}}
                          <!--                      <template v-for="tebus in desentif.desentif_detail.detail.tebus_bulan_depan">-->
                          <!--                        <span>{{tebus}} &nbsp;</span>-->
                          <!--                      </template>-->
                        </template>
                      </template>
                    </td>
                  </tr>
                </template>
                <tr class="bg-info">
                  <td colspan="2">TOTAL</td>
                  <template v-if="hidenn">
                    <td></td>
                    <td></td>
                    <td></td>
                  </template>
                  <td></td>
                  <td></td>
                  <td>

                  </td>
                  <template v-if="hidenn">
                  <td align="right">{{totalDesentif | pointmoneynotCurrency}}</td>
                  </template>
                  <td></td>
                </tr>
                </tbody>
              </table>

            </div>

          </template>
          <div id="printDesentif" v-show="false" v-if="listDesentif.length > 0">
            <laporan-desentif :desentif="listDesentif" :total="totalDesentif"/>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Detail Desentive" class="modal-info" v-model="infoModal" @ok="infoModal = false" ok-variant="info">
      <template v-if="desentive_detail.name">
        <h3>{{desentive_detail.name}}</h3>
        <hr>
        <!-- <b-dropdown-divider></b-dropdown-divider> -->
        <b-row v-get-border-color>
          <div class="col-6"><strong>Denda Bulan Lalu</strong></div>
          <div class="col-6">{{desentive_detail.denda_bulan_lalu | pointmoney }}</div>
        </b-row>
        <!-- <hr> -->

        <b-row v-get-border-color>
          <div class="col-6"><strong>Denda Bulan Lalu Terbayar</strong></div>
          <div class="col-6">{{desentive_detail.denda_bulan_lalu_terbayar | pointmoney }}</div>
        </b-row>
        <!-- <hr> -->
        <b-row v-get-border-color>
          <div class="col-6"><strong>Sisa Denda</strong></div>
          <div class="col-6">{{desentive_detail.sisa_denda | pointmoney}}</div>
        </b-row>
        <!-- <hr> -->
        <b-row v-get-border-color>
          <div class="col-6"><strong>Denda Bulan Ini</strong></div>
          <div class="col-6">{{desentive_detail.denda_bulan_ini | pointmoney }}</div>
        </b-row>
        <!-- <hr> -->
      
        <b-row v-get-border-color="'#ffa4a4'" >
          <div class="col-6"><strong>Total Denda</strong></div>
          <div class="col-6">{{desentive_detail.total_denda | pointmoney}}</div>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment'
    import LaporanDesentif from "../print/LaporanDesentif";
    import {getService} from "../../services";
    import VueHtmlToPaper from 'vue-html-to-paper';
    import Vue from 'vue';
    import {GetBorderColor} from '@/directives/detailInsentif';

    const options = {
        name: '_blank',
        specs: [
            'fullscreen=yes',
            'titlebar=yes',
            'scrollbars=no',
        ],
        styles: [
            '@/assets/scss/style.scss',
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css'
        ]
    }

    Vue.use(VueHtmlToPaper, options);


    export default {
        components: {
            DatePicker,
            LaporanDesentif
        },
        directives: {
          GetBorderColor
        },
        data() {
            return {
                branch: '',
                branchs: [],
                month: moment(),
                monthSelect: '',
                checkBranch: '',
                listDesentif: [],
                loading: false,
                totalDesentif: 0,
                hidenn: false,
                infoModal: false,
                desentive_detail: {
                    name: '',
                    denda_bulan_lalu: '0',
                    denda_bulan_lalu_terbayar: '0',
                    dendan_bulan_ini: '0',
                    sisa_denda: '0',
                    total_denda: '0',
                }
            }
        },
        created: function () {
            this.getBranch()
            var that = this
            if (this.$store.getters.branchInVendor) {
                this.branch = this.$store.getters.branchInVendor
            } else {
                this.checkBranch = setInterval(() => {
                    that.branch = that.$store.getters.branch
                    if (that.branch) {
                        clearInterval(that.checkBranch)
                    }
                }, 1000);
            }
        },
        methods: {
            async getBranch() {
                try {
                    await getService.list_branch()
                        .then(data => {
                            this.branchs = data
                        })
                } catch (error) {
                    // bila data tidak terpanggil
                }
            },
            async getDesentif(branch, year, month) {
                try {
                    this.$store.commit('noLoad', true)
                    await getService.list_desentif(branch, year, month)
                        // await getService.getJSON()
                        .then(data => {
                            let total = 0
                            this.$store.commit('noLoad', false)
                            this.loading = true
                            let desentive = []
                            for (let i in data) {
                                desentive.push(data[i])
                                total += data[i].telat.desentif + data[i].absen.desentif
                            }
                            this.totalDesentif = total
                            let employee = desentive.filter(function(employee) {
                              if ( employee.telat.desentif > 0 ||
                                  employee.absen.desentif > 0 ) {
                                  return true
                              } else if (employee.telat.desentif_detail.detail) {
                                  if (employee.telat.desentif_detail.detail.tebus_bulan_depan.length > 0) {
                                      return true
                                  }
                              }
                            })
                            employee.sort((a, b) => {
                                let nameA = a.name.toLowerCase()
                                let nameB = b.name.toLowerCase()
                                return nameA < nameB ? -1 : 1
                            })
                            this.listDesentif = employee

                        })
                } catch (error) {

                }
            },
            submit() {
                this.monthSelect = this.month
                const month = moment(this.month).format('MM')
                const year = moment(this.month).format('YYYY')
                this.getDesentif(this.branch, year, month)

            },
            print() {
                this.$htmlToPaper('printDesentif')
            },
            detailDesentive(telat, name) {
                this.infoModal = true
                const data = telat.desentif_detail.summary.denda
                this.desentive_detail = {
                    name: name,
                    denda_bulan_lalu: data.denda_bulan_lalu_seharusnya,
                    denda_bulan_lalu_terbayar: data.denda_bulan_lalu_terbayar,
                    denda_bulan_ini: data.denda_periode_ini,
                    sisa_denda: data.sisa_denda,
                    total_denda: data.total_denda_yang_harus_dibayar,
                }
            }
        },
    }
</script>
<style scoped>
  .table-sticky > thead > tr > th {
    background: #ffc107;
    color: #fff;
    top: 0px;
    position: sticky;
  }

  .table-sticky > tbody > tr:last-child > td {
    background: #62c2de;
    color: #fff;
    bottom: 0px;
    position: sticky;
  }

  .table-height {
    height: 85vh;
    display: block;
    overflow: scroll;
    width: 100%;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .show-arrow {
    position: relative;
    float: right;
    cursor: pointer;
  }


</style>
